export default __webpack_public_path__ + "static/media/bmr-example-1.dfcd8144.png";